export default __webpack_public_path__ + "static/media/back.f1545664.png";